export const getOfferSliderData = (componentData) => {
    const data = {};
    data.title = componentData?.fields?.title;
    data.subtitle = componentData?.fields?.subtitle;
    data.bgColor = componentData?.fields?.backgroundColour;
    
    if (componentData?.fields?.textStyle.length) {
        componentData.fields.textStyle.forEach(style => {
            if (style.fields.target === "Title") {
                data.titleTextColor = style.fields.color;
                return;
            }

            if (style.fields.target === "Subtitle") {
                data.subtitleTextColor = style.fields.color;
                return; 
            }

            return;
        });
    }

    data.offers = componentData?.fields?.elements?.map((i, idx) => {
        const elementFields = i?.fields;
        const sys = i?.sys;

        if(elementFields && sys) {
            return {
                position: idx,
                id: sys?.id,
                name: elementFields.name,
                hint: elementFields.hint,
                title: elementFields.title,
                textColor: elementFields.textColor,
                bgColor: elementFields.backgroundColor,
                bgImageUrl: elementFields.backgroundImage?.fields?.file?.url,
                bgImagePosition: elementFields.backgroundImagePosition,
                bgImageSize: elementFields?.backgroundImageScaling,
                actionButtonLabel: elementFields.ctaText,
                ctaLink: elementFields.ctaLink,
                ctaLinkTarget: elementFields?.ctaLinkTarget,
            };
        }
    }).filter(i => i);

    return data;
};
